export const dayOfWeekShort = {
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  be: ['Нд', 'Пн', 'Аў', 'Ср', 'Чц', 'Пт', 'Сб'],
};

export const dayOfWeek = {
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'Monday'],
  ru: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье', 'Понедельник'],
  be: ['Нядзеля', 'Панядзелак', 'Аўторак', 'Серада', 'Чацвер', 'Пятніца', 'Субота', 'Нядзеля', 'Панядзелак'],
};


export const month = {
  en: ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'],
  ru: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня',
    'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
  be: ['Студзеня', 'Лютага', 'Сакавіка', 'Красавіка', 'Мая', 'Чэрвеня',
    'Ліпеня', 'Жніўня', 'Верасня', 'Кастрычніка', 'Лістапад', 'Снежні'],
};

export const summary = {
  en: ['Feels like: ', 'Wind:', 'm/s', 'Humidity:', 'Latitude:', 'Longitude:', 'Search', 'Search for a city...'],
  ru: ['Ощущается как: ', 'Ветер:', 'м/с', 'Влажность:', 'Широта:', 'Долгота:', 'Поиск', 'Поиск по названию города...'],
  be: ['Адчуваецца як: ', 'Вецер:', 'м/с', 'Вільготнасць:', 'Шырыня:', 'Даўгата:', 'Пошук', 'Знайсці горад па назве...'],
};
